import { ChangeDetectorRef, Component, ElementRef, Input } from '@angular/core';
import { MenuGroup } from '../../models/menu-group';

@Component({
    template: '',
    standalone: true,
})
export class BaseLevelComponent {

    @Input() showMenu: boolean; //Override i child-klasser
    @Input() menuGroups: MenuGroup[]; //Override i child-klasser

    constructor(
        private ref: ChangeDetectorRef
    ) { }

    public toggleMenu() {
        this.showMenu = !this.showMenu;
        this.hideMenuGroups();
    }

    public selectedMenuGroup: MenuGroup = undefined;
    public selectedSecondMenuGroup: MenuGroup = undefined;
    public selectedThirdMenuGroup: MenuGroup = undefined;
    public activeMenuGroup: MenuGroup = undefined;

    //Göm alla menygrupper
    public hideMenuGroups() {
        this.selectedMenuGroup = undefined;
        this.selectedSecondMenuGroup = undefined;
        this.selectedThirdMenuGroup = undefined;
        this.activeMenuGroup = undefined;
    }

    /**
     * Mobiler: Scrolla ner till vald menygropp
     * (Används av de större menyerna, 3-level & 4-level)
     * @param menuId
     */
    public mobileScrollToMenu(menuId: string): void {
        //TODO: Nytt sätt för smooth scrolling

        // var browserWidth = window.innerWidth;
        // if (browserWidth < 768) {
        //     if (menuId) {
        //         let element: ElementRef = this[menuId];
        //         let top = element.nativeElement.getBoundingClientRect().top;
        //         console.log(menuId+", top: "+top);
        //         if (element) {
        //             setTimeout(() => {
        //                 this.scrollingService.scrollToElement(element, 1500);
        //             }, 250);
        //         }
        //     } else {
        //         return;
        //     }
        // }
    }

    /**
     * Stäng menyer när användaren klickar någonstans utanför menyn
     * (Kontrollerar tio steg upp i html-parents om elementet har id "main-menu")
     * @param event
     */
    public closeMenuWhenClickingElsewhere(event): boolean {
        let clickedElement = event.target;
        if (!clickedElement) return true;

        // eId = elementId samt p1Id = parentId, p2Id = parentsparentId, etc.
        let eId = clickedElement.id;
        let p1 = clickedElement.parentElement;

        let p1Id = p1 != null ? p1.id : "";
        let p2 = p1 != null ? p1.parentElement : null;

        let p2Id = p1 != null && p2 != null ? p2.id : "";
        let p3 = p2 != null ? p2.parentElement : null;
        let p3Id = p1 != null && p2 != null && p3 != null ? p3.id : "";
        let p4 = p3 != null ? p3.parentElement : null;
        let p4Id = p1 != null && p2 != null && p3 != null && p4 != null ? p4.id : "";
        let p5 = p4 != null ? p4.parentElement : null;
        let p5Id = p1 != null && p2 != null && p3 != null && p4 != null && p5 != null ? p5.id : "";
        let p6 = p5 != null ? p5.parentElement : null;
        let p6Id = p1 != null && p2 != null && p3 != null && p4 != null && p5 != null && p6 != null ? p6.id : "";
        let p7 = p6 != null ? p6.parentElement : null;
        let p7Id = p1 != null && p2 != null && p3 != null && p4 != null && p5 != null && p6 != null && p7 != null ? p7.id : "";
        let p8 = p7 != null ? p7.parentElement : null;
        let p8Id = p1 != null && p2 != null && p3 != null && p4 != null && p5 != null && p6 != null && p7 != null && p8 != null ? p8.id : "";
        let p9 = p8 != null ? p8.parentElement : null;
        let p9Id = p1 != null && p2 != null && p3 != null && p4 != null && p5 != null && p6 != null && p7 != null && p8 != null && p9 != null ? p9.id : "";
        let p10 = p9 != null ? p9.parentElement : null;
        let p10Id = p1 != null && p2 != null && p3 != null && p4 != null && p5 != null && p6 != null && p7 != null && p8 != null && p9 != null && p10 != null ? p10.id : "";

        var clickedInsideMenu = eId === "main-menu" || p1Id === "main-menu" || p2Id === "main-menu" || p3Id === "main-menu" || p4Id === "main-menu" || p5Id === "main-menu" || p6Id === "main-menu" || p7Id === "main-menu" || p8Id === "main-menu" || p9Id === "main-menu" || p10Id === "main-menu";

        if (!clickedInsideMenu) {
            this.showMenu = false;
            this.hideMenuGroups();
            this.ref.detectChanges();
            return true;
        }
        else {
            return false;
        }
    }
}
